import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accountManager", "contractManager", "isSaving", "isStarterPortal", "selectedOption"];
import I18n from 'I18n';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import AccountManager from '../../records/AccountManager';
import ContractManager from '../../records/ContractManager';
import SavableFormLabel from './SavableFormLabel';
import { ACCOUNT_MANAGER, BILLING, CONTRACT_MANAGER, DELIVERABILITY, PRIVACY, SECURITY, PAYMENT } from '../../constants/EscalationType';
const ESCALATION_TYPES = [ACCOUNT_MANAGER, CONTRACT_MANAGER, DELIVERABILITY, SECURITY, PRIVACY, BILLING, PAYMENT];
import { SUCCESS_OWNER } from '../../constants/ManagerType';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EscalateToSelect(_ref) {
  let {
      accountManager = null,
      contractManager = null,
      isSaving = false,
      isStarterPortal = false,
      selectedOption = undefined
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const props = Object.assign({
    accountManager,
    contractManager,
    isSaving,
    isStarterPortal,
    selectedOption
  }, rest);
  const optionTypes = ESCALATION_TYPES.slice(2);
  optionTypes.unshift(props.isStarterPortal ? CONTRACT_MANAGER : ACCOUNT_MANAGER);
  function getAccountManagerOptionText(value) {
    let langPath;
    if (props.accountManager) {
      langPath = props.accountManager.type === SUCCESS_OWNER ? '.success' : '.onboarding';
    } else {
      langPath = '.empty';
    }
    return I18n.text(`app.escalations.fields.escalateTo.options.${value}${langPath}`, {
      owner: props.accountManager ? props.accountManager.name : ''
    });
  }
  function getContractManagerOptionText(value) {
    let langPath;
    if (props.contractManager) {
      langPath = '.team';
    } else {
      langPath = '.empty';
    }
    return I18n.text(`app.escalations.fields.escalateTo.options.${value}${langPath}`);
  }
  function getOptionText(value) {
    switch (value) {
      case ACCOUNT_MANAGER:
        return getAccountManagerOptionText(value);
        break;
      case CONTRACT_MANAGER:
        return getContractManagerOptionText(value);
      default:
        return I18n.text(`app.escalations.fields.escalateTo.options.${value}`);
        break;
    }
  }
  function isEscalationToManagerDisabled(value) {
    return value === ACCOUNT_MANAGER && !props.accountManager || value === CONTRACT_MANAGER && !props.contractManager;
  }
  function getSelectedOptionIfValid() {
    if (props.selectedOption === CONTRACT_MANAGER && (!props.contractManager || !props.isStarterPortal)) {
      return undefined;
    }
    return props.selectedOption;
  }
  const options = optionTypes.map(value => ({
    disabled: isEscalationToManagerDisabled(value),
    text: getOptionText(value),
    value
  }));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavableFormLabel, {
      "data-test-id": "escalate-to-select-label",
      isSaving: props.isSaving,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.fields.escalateTo.label"
      })
    }), /*#__PURE__*/_jsx(Select, {
      "data-test-id": "escalate-to-select-select",
      onChange: ({
        target: {
          value
        }
      }) => props.onSelect(value),
      options: options,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.fields.escalateTo.placeholder"
      }),
      value: getSelectedOptionIfValid()
    })]
  });
}
EscalateToSelect.propTypes = {
  accountManager: PropTypes.instanceOf(AccountManager),
  contractManager: PropTypes.instanceOf(ContractManager),
  isSaving: PropTypes.bool,
  isStarterPortal: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedOption: PropTypes.string
};
export default EscalateToSelect;